import { addZeroBeforeTimeUnit } from 'functions/number/addZeroBeforeTimeUnit'

/** Возвращает строку типа 3:20:55 */
export const getCountdown = (diff: number): string => {
  let seconds = Math.floor(diff / 1000)
  const hours = Math.floor(seconds / 3600)
  seconds %= 3600
  const minutes = Math.floor(seconds / 60)
  seconds %= 60

  // prettier-ignore
  return `${hours}:${addZeroBeforeTimeUnit(minutes)}:${addZeroBeforeTimeUnit(seconds)}`;
}
